import { render } from "./InputRadio.vue?vue&type=template&id=dc9fd76a"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"

import "./InputRadio.vue?vue&type=style&index=0&id=dc9fd76a&lang=scss"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__